import { useContext, useState } from "react"
import cartContext from "./cartContext"
import userContext from "./userContext"
import { useSnackbar } from "./snackbar"

const CartUpdater = (props) => {
  const { setCart } = useContext(cartContext)
  const { user } = useContext(userContext)
  const { showSnackbar } = useSnackbar()

  const [loading, setLoading] = useState(false)

  const product = props?.item?.product || props?.item

  /* ===============================
     NORMALIZED ITEM (MATCH BACKEND)
  =============================== */
  const item = {
    product_id: product?.product_id,
    product_name: product?.name,
    product_price: Number(product?.price || 0),
    qty: props?.item?.qty || 1,
    image: product?.image || props?.item?.image,
  }

  /* ===============================
     ADD TO CART
  =============================== */
  const updateCart = async () => {
    try {
      setLoading(true)

      const res = await fetch(`${process.env.REACT_APP_API_URL}/me/cart/add`, {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ item }),
      })

      if (!res.ok) throw new Error("Cart update failed")

      const updatedCart = await res.json()

      // backend is source of truth
      setCart(updatedCart)

      showSnackbar("Added to cart", "success")
    } catch (err) {
      console.error("Cart update error:", err)
      showSnackbar("Failed to add item to cart", "error")
    } finally {
      setLoading(false)
    }
  }

  /* ===============================
     CLICK HANDLER
  =============================== */
  const handleClick = async (e) => {
    e.stopPropagation()
    e.preventDefault()

    if (loading) return

    if (!user) {
      showSnackbar("Please sign in to add items to cart", "warning")
      return
    }

    await updateCart()
  }

  return (
    <button
      className={"btn " + (props.classes || "")}
      onClick={handleClick}
      disabled={loading}
      style={props.styling}
    >
      {loading ? "Adding..." : "Add to cart"}
    </button>
  )
}

export default CartUpdater
